
import { TableCell, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

interface OrganizationsTableStatusProps {
  loading: boolean;
  isEmpty: boolean;
}

export function OrganizationsTableStatus({ loading, isEmpty }: OrganizationsTableStatusProps) {
  if (loading) {
    return (
      <>
        {Array.from({ length: 3 }).map((_, index) => (
          <TableRow key={index}>
            <TableCell><Skeleton className="h-4 w-32" /></TableCell>
            <TableCell><Skeleton className="h-4 w-24" /></TableCell>
            <TableCell><Skeleton className="h-8 w-8 rounded" /></TableCell>
          </TableRow>
        ))}
      </>
    );
  }

  if (isEmpty) {
    return (
      <TableRow>
        <TableCell colSpan={3} className="text-center py-8 text-muted-foreground">
          Nenhuma organização encontrada.
        </TableCell>
      </TableRow>
    );
  }

  return null;
}
